// How we know the patient consented to being referred — the three ways it
// reaches us. Not a channel and not a workflow step: it answers "what is our
// evidence?", which is the question a nurse, an auditor and a developer all
// ask of a consent.
export enum ReferralConsentEvidence {
  // The referrer says so, ticking "I confirm I have consent from the patient
  // to refer them to Perci Health" — or, for a system-to-system integration,
  // by referring at all. We hold no document.
  referrerAttested = 'referrer-attested',
  // The patient's signed consent form is attached to the referral (see
  // ReferralDocumentType.patientReferralConsent).
  signedForm = 'signed-form',
  // We ask the patient ourselves, by telephone, before the referral proceeds.
  // The only evidence that is not in hand when the referral arrives.
  phoneCall = 'phone-call',
}

export function displayReferralConsentEvidence(value: ReferralConsentEvidence) {
  switch (value) {
    case ReferralConsentEvidence.referrerAttested:
      return 'Confirmed by the referrer';
    case ReferralConsentEvidence.signedForm:
      return 'Signed consent form';
    case ReferralConsentEvidence.phoneCall:
      return 'Telephone call with the patient';
    default:
      throw new Error(`Unknown referral consent evidence: ${value}`);
  }
}

export function isReferralConsentEvidence(
  value: unknown,
): value is ReferralConsentEvidence {
  return Object.values<unknown>(ReferralConsentEvidence).includes(value);
}
